export const cleanNumber = (number) => {
  if (number === undefined || number === null || number === '') {
    return 0;
  }

  if (typeof number === 'number') {
    return number;
  }

  if (typeof number === 'string') {
    const cleanedString = number.replace(/[$,]/g, '');
    const numericValue = parseFloat(cleanedString);
    return isNaN(numericValue) ? 0 : numericValue;
  }

  return 0;
};
